import React from 'react';
import { useAuth } from '@/hooks/useAuth';
import { AppShell } from './AppShell';
import { PublicPageShell } from './PublicPageShell';

/**
 * OptionalAppShell renders the authenticated app chrome (sidebar, top bar,
 * mobile bottom nav) only when a session exists. Signed-out visitors get a
 * bare page — used for public share views like member profiles so that
 * signed-in users never lose their navigation.
 */
export const OptionalAppShell: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <>{children}</>;
  return user ? <AppShell>{children}</AppShell> : <PublicPageShell>{children}</PublicPageShell>;
};

export default OptionalAppShell;
